import { getRoleId } from '@/utils/auth'
import request from '@/utils/request'


// 查询展会列表 
export function queryListPage(data) {
    const roleId = getRoleId();
    if(roleId === '1') {
        // 主场
        return request({
            url: '/api/homecourt/exhibition/list/page',
            method: 'get',
            params: data
          }) 
    } else {
        // 搭建商
        return request({
            url: '/api/builder/exhibition/page',
            method: 'get',
            params: data
          }) 
    }

}

// 展会列表：切换当前选中展会
export function switchCurrentExhibitionApi(data) {
      // 主场
      return request({
        url: '/api/exhibition/updateCurrent',
        method: 'post',
        data: data
    })
}

// 进入展会：查询展会基本信息
export function exhibitionBaseInfoApi(data) {
    const roleId = getRoleId();
    if(roleId === '1') {
        // 主场
        return request({
            url: '/api/homecourt/exhibition/list/info',
            method: 'get',
            params: data
        })
    } else {
        // 搭建商
        return request({
            url: '/api/builder/exhibition/info',
            method: 'get',
            params: data
          }) 
    }
}


// 主场额外功能：查询邀请码信息
export function queryInviteCodeApi(data) {
    return request({
        url: '/api/homecourt/exhibition/list/invitation/info',
        method: 'get',
        params: data
      })
    
}
// 主场额外功能：更新邀请码信息
export function updateInviteCodeApi(data) {
    return request({
        url: '/api/homecourt/exhibition/list/invitation/update',
        method: 'post',
        data: data
      })
    
}

// 搭建商额外功能：加入展会
export function joinExhibitionApi(data) {
    return request({
        url: '/api/builder/exhibition/join',
        method: 'post',
        data: data
      })
    
}


// 查询展会详情
export function queryExhibitionDetailApi(data) {
    return request({
        url: '/api/homecourt/exhibition/list/detail',
        method: 'get',
        params: data
      })
    
}

// 查询项目列表
export function getProjectListApi(data) {
    return request({
        url: '/api/platform/exhibition/query/projectList',
        method: 'get',
        params: data
      })
    
}

// 更新展会信息
export function updateExhibitionApi(data) {
    return request({
        url: '/api/platform/exhibition/addOrUpdate',
        method: 'post',
        data:data
    })
    
}

// 删除展会
export function deleteExhibitionApi(data) {
    return request({
        url: '/api/platform/exhibition/delete',
        method: 'post',
        data: data
    })
}

// 主场删除展会
export function homecourtDeleteExhibitionApi(data) {
    return request({
        url: '/api/homecourt/exhibition/list/delete',
        method: 'get',
        params: data
    })
}


// 进入展会：查询当前展会
export function getCurrentExhibitionApi(data) {
    return request({
        url: '/api/exhibition/getCurrent',
        method: 'get',
        params: data
    })
    
}

// /dic/industryList 查询行业列表
export function industryListApi(data) {
    const roleId = getRoleId();
    if(roleId === '1') {
        // 主场
        return request({
            url: '/api/homecourt/exhibition/list/industryList',
            method: 'get',
            params: data
        })
    } else {
        // 搭建商
        return request({
            url: '/api/builder/exhibition/industryList',
            method: 'get',
            params: data
        })
    }
}

// /dic/regionList 查询地区列表
export function regionListApi(data) {
    const roleId = getRoleId();
    if(roleId === '1') {
        // 主场
        return request({
            url: '/api/homecourt/exhibition/list/regionList',
            method: 'get',
            params: data
        })
    } else {
        // 搭建商
        return request({
            url: '/api/builder/exhibition/regionList',
            method: 'get',
            params: data
        })
    }
}

// 主场角色添加/修改展会
export function homecourtAddUpdateExhibitionApi(data) {
    return request({
        url: '/api/homecourt/exhibition/list/addUpdate',
        method: 'post',
        data: data
    })
}

// 查询可关联的展会列表
export function getAssociableExhibitionApi(data) {
    return request({
        url: '/api/homecourt/exhibition/list/associableExhibition',
        method: 'get',
        params: data
    })
}

// 关联展会
export function mergeExhibitionApi(data) {
    return request({
        url: '/api/homecourt/exhibition/list/mergeExhibition',
        method: 'get',
        params: data
    })
}
